export interface ProfileTheme {
  id: string;
  name: string;
  blurb: string;
  swatch: string[];
  mood: string;
}

export const PROFILE_THEMES: ProfileTheme[] = [
  {
    id: 'editoriale',
    name: 'Editoriale',
    blurb: 'Serif, parchment, generous whitespace',
    swatch: ['#FAF8F5', '#3D3328', '#6B7A5A'],
    mood: 'Calm · editorial',
  },
  {
    id: 'notte',
    name: 'Notte',
    blurb: 'Near-black with goldenrod, high contrast',
    swatch: ['#1A1A1A', '#F4D03F', '#E8DFD3'],
    mood: 'Bold · inverted',
  },
  {
    id: 'costiera',
    name: 'Costiera',
    blurb: 'Full-bleed coastline, frosted link cards',
    swatch: ['#1d3a3a', '#E8DFD3', '#F4D03F'],
    mood: 'Photo-led · immersive',
  },
  {
    id: 'terra',
    name: 'Terra',
    blurb: 'Sand ground, soft rounded tiles',
    swatch: ['#E8DFD3', '#FFFFFF', '#6B7A5A'],
    mood: 'Warm · tactile',
  },
];

export const PROFILE_ACCENTS = [
  '#6B7A5A',
  '#B89E7E',
  '#8A9B6F',
  '#C9B896',
  '#1A1A1A',
  '#C16B5F',
] as const;

export function getThemeById(themeId: string): ProfileTheme | undefined {
  return PROFILE_THEMES.find((t) => t.id === themeId);
}
